import {
  AbiConstructorNotFoundError,
  AbiConstructorParamsNotFoundError,
  AbiDecodingDataSizeInvalidError,
  AbiDecodingZeroDataError,
  AbiEncodingArrayLengthMismatchError,
  AbiEncodingLengthMismatchError,
  AbiErrorInputsNotFoundError,
  AbiErrorNotFoundError,
  AbiErrorSignatureNotFoundError,
  AbiEventNotFoundError,
  AbiEventSignatureEmptyTopicsError,
  AbiEventSignatureNotFoundError,
  AbiFunctionNotFoundError,
  AbiFunctionOutputsNotFoundError,
  AbiFunctionSignatureNotFoundError,
  BaseError,
  BlockNotFoundError,
  CallExecutionError,
  ChainDoesNotSupportContract,
  ContractFunctionExecutionError,
  ContractFunctionRevertedError,
  ContractFunctionZeroDataError,
  DataLengthTooLongError,
  DataLengthTooShortError,
  DecodeLogTopicsMismatch,
  EnsAvatarUriResolutionError,
  EstimateGasExecutionError,
  ExecutionRevertedError,
  FeeCapTooHighError,
  FeeCapTooLowError,
  FilterTypeNotSupportedError,
  HttpRequestError,
  InsufficientFundsError,
  InternalRpcError,
  IntrinsicGasTooHighError,
  IntrinsicGasTooLowError,
  InvalidAbiDecodingTypeError,
  InvalidAbiEncodingTypeError,
  InvalidAddressError,
  InvalidArrayError,
  InvalidBytesBooleanError,
  InvalidChainIdError,
  InvalidDefinitionTypeError,
  InvalidHexBooleanError,
  InvalidHexValueError,
  InvalidInputRpcError,
  InvalidLegacyVError,
  InvalidParamsRpcError,
  InvalidRequestRpcError,
  JsonRpcVersionUnsupportedError,
  LimitExceededRpcError,
  MethodNotFoundRpcError,
  MethodNotSupportedRpcError,
  NonceMaxValueError,
  NonceTooHighError,
  NonceTooLowError,
  OffsetOutOfBoundsError,
  ParseRpcError,
  RawContractError,
  RequestError,
  ResourceNotFoundRpcError,
  ResourceUnavailableRpcError,
  RpcError,
  RpcRequestError,
  SizeExceedsPaddingSizeError,
  SwitchChainError,
  TimeoutError,
  TipAboveFeeCapError,
  TransactionExecutionError,
  TransactionNotFoundError,
  TransactionReceiptNotFoundError,
  TransactionRejectedRpcError,
  TransactionTypeNotSupportedError,
  UnknownNodeError,
  UnknownRpcError,
  UrlRequiredError,
  UserRejectedRequestError,
  WaitForTransactionReceiptTimeoutError,
  WebSocketRequestError,
  addChain,
  assertRequest,
  assertTransactionEIP1559,
  assertTransactionEIP2930,
  assertTransactionLegacy,
  boolToBytes,
  boolToHex,
  buildRequest,
  bytesToBigint,
  bytesToBool,
  bytesToHex,
  bytesToNumber,
  bytesToString,
  call,
  concat,
  concatBytes,
  concatHex,
  createBlockFilter,
  createContractEventFilter,
  createEventFilter,
  createPendingTransactionFilter,
  decodeAbiParameters,
  decodeErrorResult,
  decodeEventLog,
  decodeFunctionData,
  decodeFunctionResult,
  defineBlock,
  defineChain,
  defineTransaction,
  defineTransactionReceipt,
  defineTransactionRequest,
  deployContract,
  dropTransaction,
  encodeAbiParameters,
  encodeDeployData,
  encodeErrorResult,
  encodeEventTopics,
  encodeFunctionData,
  encodeFunctionResult,
  encodePacked,
  estimateContractGas,
  estimateGas,
  etherUnits,
  formatBlock,
  formatEther,
  formatGwei,
  formatTransaction,
  formatTransactionRequest,
  formatUnits,
  fromBytes,
  fromHex,
  fromRlp,
  getAbiItem,
  getAddress,
  getAddresses,
  getAutomine,
  getBalance,
  getBlock,
  getBlockNumber,
  getBlockTransactionCount,
  getBytecode,
  getChainId,
  getContract,
  getContractAddress,
  getContractError,
  getCreate2Address,
  getCreateAddress,
  getEnsAddress,
  getEnsAvatar,
  getEnsName,
  getEnsResolver,
  getEnsText,
  getEventSelector,
  getFeeHistory,
  getFilterChanges,
  getFilterLogs,
  getFunctionSelector,
  getGasPrice,
  getLogs,
  getPermissions,
  getSerializedTransactionType,
  getSocket,
  getStorageAt,
  getTransaction,
  getTransactionConfirmations,
  getTransactionCount,
  getTransactionReceipt,
  getTransactionType,
  getTxpoolContent,
  getTxpoolStatus,
  gweiUnits,
  hashMessage,
  hashTypedData,
  hexToBigInt,
  hexToBool,
  hexToBytes,
  hexToNumber,
  hexToString,
  impersonateAccount,
  increaseTime,
  inspectTxpool,
  isAddress,
  isAddressEqual,
  isBytes,
  isDeterministicError,
  isHash,
  isHex,
  keccak256,
  labelhash,
  mine,
  multicall,
  multicall3Abi,
  namehash,
  numberToBytes,
  numberToHex,
  pad,
  padBytes,
  padHex,
  parseAbi,
  parseAbiItem,
  parseAbiParameter,
  parseAbiParameters,
  parseAccount,
  parseEther,
  parseGwei,
  parseTransaction,
  parseUnits,
  prepareRequest,
  readContract,
  recoverAddress,
  recoverMessageAddress,
  recoverTypedDataAddress,
  removeBlockTimestampInterval,
  requestAddresses,
  requestPermissions,
  reset,
  revert,
  rpc,
  sendTransaction,
  sendUnsignedTransaction,
  serializeTransaction,
  setAutomine,
  setBalance,
  setBlockGasLimit,
  setBlockTimestampInterval,
  setCode,
  setCoinbase,
  setIntervalMining,
  setLoggingEnabled,
  setMinGasPrice,
  setNextBlockBaseFeePerGas,
  setNextBlockTimestamp,
  setNonce,
  setRpcUrl,
  setStorageAt,
  signMessage,
  signTypedData,
  simulateContract,
  size,
  slice,
  sliceBytes,
  sliceHex,
  snapshot,
  stopImpersonatingAccount,
  stringToBytes,
  stringToHex,
  stringify,
  switchChain,
  toBytes,
  toHex,
  toRlp,
  transactionType,
  trim,
  uninstallFilter,
  validateTypedData,
  verifyMessage,
  verifyTypedData,
  wait,
  waitForTransactionReceipt,
  watchAsset,
  watchBlockNumber,
  watchBlocks,
  watchContractEvent,
  watchEvent,
  watchPendingTransactions,
  weiUnits,
  writeContract
} from "./chunk-6T6EZJGF.mjs";

// src/clients/transports/createTransport.ts
function createTransport({
  key,
  name,
  request,
  retryCount = 3,
  retryDelay = 150,
  timeout,
  type
}, value) {
  return {
    config: { key, name, request, retryCount, retryDelay, timeout, type },
    request: buildRequest(request, { retryCount, retryDelay }),
    value
  };
}

// src/clients/transports/custom.ts
function custom(provider, config = {}) {
  const { key = "custom", name = "Custom Provider", retryDelay } = config;
  return ({ retryCount: defaultRetryCount }) => createTransport({
    key,
    name,
    request: provider.request.bind(provider),
    retryCount: config.retryCount ?? defaultRetryCount,
    retryDelay,
    type: "custom"
  });
}

// src/clients/transports/fallback.ts
function fallback(transports_, config = {}) {
  const {
    key = "fallback",
    name = "Fallback",
    rank = true,
    retryCount,
    retryDelay
  } = config;
  return ({ chain, pollingInterval = 4e3, timeout }) => {
    let transports = transports_;
    const transport = createTransport(
      {
        key,
        name,
        async request({ method, params }) {
          const fetch = async (i = 0) => {
            const transport2 = transports[i]({ chain, retryCount: 0, timeout });
            try {
              return await transport2.request({
                method,
                params
              });
            } catch (err) {
              if (isDeterministicError(err))
                throw err;
              if (i === transports.length - 1)
                throw err;
              return fetch(i + 1);
            }
          };
          return fetch();
        },
        retryCount,
        retryDelay,
        type: "fallback"
      },
      {
        transports: transports.map((fn) => fn({ chain, retryCount: 0 }))
      }
    );
    if (rank) {
      const rankOptions = typeof rank === "object" ? rank : {};
      rankTransports({
        chain,
        interval: rankOptions.interval ?? pollingInterval,
        onTransports: (transports_2) => transports = transports_2,
        sampleCount: rankOptions.sampleCount,
        timeout: rankOptions.timeout,
        transports,
        weights: rankOptions.weights
      });
    }
    return transport;
  };
}
function rankTransports({
  chain,
  interval = 4e3,
  onTransports,
  sampleCount = 10,
  timeout = 1e3,
  transports,
  weights = {}
}) {
  const { stability: stabilityWeight = 0.7, latency: latencyWeight = 0.3 } = weights;
  const samples = [];
  const rankTransports_ = async () => {
    const sample = await Promise.all(
      transports.map(async (transport) => {
        const transport_ = transport({ chain, retryCount: 0, timeout });
        const start = Date.now();
        let end;
        let success;
        try {
          await transport_.request({ method: "net_listening" });
          success = 1;
        } catch {
          success = 0;
        } finally {
          end = Date.now();
        }
        const latency = end - start;
        return { latency, success };
      })
    );
    samples.push(sample);
    if (samples.length > sampleCount)
      samples.shift();
    const maxLatency = Math.max(
      ...samples.map(
        (sample2) => Math.max(...sample2.map(({ latency }) => latency))
      )
    );
    const scores = transports.map((_, i) => {
      const latencies = samples.map((sample2) => sample2[i].latency);
      const meanLatency = latencies.reduce((acc, latency) => acc + latency, 0) / latencies.length;
      const latencyScore = 1 - meanLatency / maxLatency;
      const successes = samples.map((sample2) => sample2[i].success);
      const stabilityScore = successes.reduce((acc, success) => acc + success, 0) / successes.length;
      if (stabilityScore === 0)
        return [0, i];
      return [
        latencyWeight * latencyScore + stabilityWeight * stabilityScore,
        i
      ];
    }).sort((a, b) => b[0] - a[0]);
    onTransports(scores.map(([, i]) => transports[i]));
    await wait(interval);
    rankTransports_();
  };
  rankTransports_();
}

// src/clients/transports/http.ts
function http(url, config = {}) {
  const {
    fetchOptions,
    key = "http",
    name = "HTTP JSON-RPC",
    retryDelay
  } = config;
  return ({ chain, retryCount: retryCount_, timeout: timeout_ }) => {
    const retryCount = config.retryCount ?? retryCount_;
    const timeout = timeout_ ?? config.timeout ?? 1e4;
    const url_ = url || chain?.rpcUrls.default.http[0];
    if (!url_)
      throw new UrlRequiredError();
    return createTransport(
      {
        key,
        name,
        async request({ method, params }) {
          const { result } = await rpc.http(url_, {
            body: {
              method,
              params
            },
            fetchOptions,
            timeout
          });
          return result;
        },
        retryCount,
        retryDelay,
        timeout,
        type: "http"
      },
      {
        url
      }
    );
  };
}

// src/clients/transports/webSocket.ts
function webSocket(url, config = {}) {
  const { key = "webSocket", name = "WebSocket JSON-RPC", retryDelay } = config;
  return ({ chain, retryCount: retryCount_, timeout: timeout_ }) => {
    const retryCount = config.retryCount ?? retryCount_;
    const timeout = timeout_ ?? config.timeout ?? 1e4;
    const url_ = url || chain?.rpcUrls.default.webSocket?.[0];
    if (!url_)
      throw new UrlRequiredError();
    return createTransport(
      {
        key,
        name,
        async request({ method, params }) {
          const socket = await getSocket(url_);
          const { result } = await rpc.webSocketAsync(socket, {
            body: { method, params },
            timeout
          });
          return result;
        },
        retryCount,
        retryDelay,
        timeout,
        type: "webSocket"
      },
      {
        getSocket() {
          return getSocket(url_);
        },
        async subscribe({ params, onData, onError }) {
          const socket = await getSocket(url_);
          const { result: subscriptionId } = await new Promise(
            (resolve, reject) => rpc.webSocket(socket, {
              body: {
                method: "eth_subscribe",
                params
              },
              onData: (data) => {
                if (typeof data.id === "number") {
                  resolve(data);
                  return;
                }
                if (data.method !== "eth_subscription")
                  return;
                onData(data.params);
              },
              onError: (error) => {
                reject(error);
                onError?.(error);
              }
            })
          );
          return {
            subscriptionId,
            async unsubscribe() {
              return new Promise(
                (resolve, reject) => rpc.webSocket(socket, {
                  body: {
                    method: "eth_unsubscribe",
                    params: [subscriptionId]
                  },
                  onData: resolve,
                  onError: reject
                })
              );
            }
          };
        }
      }
    );
  };
}

// src/utils/uid.ts
var size2 = 256;
var index = size2;
var buffer;
function uid(length = 11) {
  if (!buffer || index + length > size2 * 2) {
    buffer = "";
    index = 0;
    for (let i = 0; i < size2; i++) {
      buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
  }
  return buffer.substring(index, index++ + length);
}

// src/clients/createClient.ts
function createClient({
  chain,
  key = "base",
  name = "Base Client",
  pollingInterval = 4e3,
  transport,
  type = "base"
}) {
  const { config, request, value } = transport({ chain, pollingInterval });
  return {
    chain,
    key,
    name,
    pollingInterval,
    request,
    transport: { ...config, ...value },
    type,
    uid: uid()
  };
}

// src/clients/decorators/public.ts
var publicActions = (client) => ({
  call: (args) => call(client, args),
  createBlockFilter: () => createBlockFilter(client),
  createContractEventFilter: (args) => createContractEventFilter(client, args),
  createEventFilter: (args) => createEventFilter(client, args),
  createPendingTransactionFilter: () => createPendingTransactionFilter(client),
  estimateContractGas: (args) => estimateContractGas(client, args),
  estimateGas: (args) => estimateGas(client, args),
  getBalance: (args) => getBalance(client, args),
  getBlock: (args) => getBlock(client, args),
  getBlockNumber: (args) => getBlockNumber(client, args),
  getBlockTransactionCount: (args) => getBlockTransactionCount(client, args),
  getBytecode: (args) => getBytecode(client, args),
  getChainId: () => getChainId(client),
  getEnsAddress: (args) => getEnsAddress(client, args),
  getEnsAvatar: (args) => getEnsAvatar(client, args),
  getEnsName: (args) => getEnsName(client, args),
  getEnsResolver: (args) => getEnsResolver(client, args),
  getEnsText: (args) => getEnsText(client, args),
  getFeeHistory: (args) => getFeeHistory(client, args),
  getFilterChanges: (args) => getFilterChanges(client, args),
  getFilterLogs: (args) => getFilterLogs(client, args),
  getGasPrice: () => getGasPrice(client),
  getLogs: (args) => getLogs(client, args),
  getStorageAt: (args) => getStorageAt(client, args),
  getTransaction: (args) => getTransaction(client, args),
  getTransactionConfirmations: (args) => getTransactionConfirmations(client, args),
  getTransactionCount: (args) => getTransactionCount(client, args),
  getTransactionReceipt: (args) => getTransactionReceipt(client, args),
  multicall: (args) => multicall(client, args),
  readContract: (args) => readContract(client, args),
  simulateContract: (args) => simulateContract(client, args),
  uninstallFilter: (args) => uninstallFilter(client, args),
  waitForTransactionReceipt: (args) => waitForTransactionReceipt(client, args),
  watchBlocks: (args) => watchBlocks(client, args),
  watchBlockNumber: (args) => watchBlockNumber(client, args),
  watchContractEvent: (args) => watchContractEvent(client, args),
  watchEvent: (args) => watchEvent(client, args),
  watchPendingTransactions: (args) => watchPendingTransactions(client, args)
});

// src/clients/decorators/test.ts
function testActions(client) {
  return {
    dropTransaction: (args) => dropTransaction(client, args),
    getAutomine: () => getAutomine(client),
    getTxpoolContent: () => getTxpoolContent(client),
    getTxpoolStatus: () => getTxpoolStatus(client),
    impersonateAccount: (args) => impersonateAccount(client, args),
    increaseTime: (args) => increaseTime(client, args),
    inspectTxpool: () => inspectTxpool(client),
    mine: (args) => mine(client, args),
    removeBlockTimestampInterval: () => removeBlockTimestampInterval(client),
    reset: (args) => reset(client, args),
    revert: (args) => revert(client, args),
    sendUnsignedTransaction: (args) => sendUnsignedTransaction(client, args),
    setAutomine: (args) => setAutomine(client, args),
    setBalance: (args) => setBalance(client, args),
    setBlockGasLimit: (args) => setBlockGasLimit(client, args),
    setBlockTimestampInterval: (args) => setBlockTimestampInterval(client, args),
    setCode: (args) => setCode(client, args),
    setCoinbase: (args) => setCoinbase(client, args),
    setIntervalMining: (args) => setIntervalMining(client, args),
    setLoggingEnabled: (args) => setLoggingEnabled(client, args),
    setMinGasPrice: (args) => setMinGasPrice(client, args),
    setNextBlockBaseFeePerGas: (args) => setNextBlockBaseFeePerGas(client, args),
    setNextBlockTimestamp: (args) => setNextBlockTimestamp(client, args),
    setNonce: (args) => setNonce(client, args),
    setRpcUrl: (args) => setRpcUrl(client, args),
    setStorageAt: (args) => setStorageAt(client, args),
    snapshot: () => snapshot(client),
    stopImpersonatingAccount: (args) => stopImpersonatingAccount(client, args)
  };
}

// src/clients/decorators/wallet.ts
var walletActions = (client) => ({
  addChain: (args) => addChain(client, args),
  deployContract: (args) => deployContract(client, args),
  getAddresses: () => getAddresses(client),
  getChainId: () => getChainId(client),
  getPermissions: () => getPermissions(client),
  requestAddresses: () => requestAddresses(client),
  requestPermissions: (args) => requestPermissions(client, args),
  sendTransaction: (args) => sendTransaction(client, args),
  signMessage: (args) => signMessage(client, args),
  signTypedData: (args) => signTypedData(client, args),
  switchChain: (args) => switchChain(client, args),
  watchAsset: (args) => watchAsset(client, args),
  writeContract: (args) => writeContract(client, args)
});

// src/clients/createPublicClient.ts
function createPublicClient({
  chain,
  key = "public",
  name = "Public Client",
  transport,
  pollingInterval
}) {
  const client = createClient({
    chain,
    key,
    name,
    pollingInterval,
    transport,
    type: "publicClient"
  });
  return {
    ...client,
    ...publicActions(client)
  };
}

// src/clients/createTestClient.ts
function createTestClient({
  chain,
  key = "test",
  name = "Test Client",
  mode,
  pollingInterval,
  transport
}) {
  const client = {
    ...createClient({
      chain,
      key,
      name,
      pollingInterval,
      transport,
      type: "testClient"
    }),
    mode
  };
  return {
    ...client,
    ...testActions(client)
  };
}

// src/clients/createWalletClient.ts
function createWalletClient({
  account,
  chain,
  transport,
  key = "wallet",
  name = "Wallet Client",
  pollingInterval
}) {
  const client = {
    ...createClient({
      chain,
      key,
      name,
      pollingInterval,
      transport: (opts) => transport({ ...opts, retryCount: 0 }),
      type: "walletClient"
    }),
    account: account ? parseAccount(account) : void 0
  };
  return {
    ...client,
    ...walletActions(client)
  };
}
export {
  AbiConstructorNotFoundError,
  AbiConstructorParamsNotFoundError,
  AbiDecodingDataSizeInvalidError,
  AbiDecodingZeroDataError,
  AbiEncodingArrayLengthMismatchError,
  AbiEncodingLengthMismatchError,
  AbiErrorInputsNotFoundError,
  AbiErrorNotFoundError,
  AbiErrorSignatureNotFoundError,
  AbiEventNotFoundError,
  AbiEventSignatureEmptyTopicsError,
  AbiEventSignatureNotFoundError,
  AbiFunctionNotFoundError,
  AbiFunctionOutputsNotFoundError,
  AbiFunctionSignatureNotFoundError,
  BaseError,
  BlockNotFoundError,
  CallExecutionError,
  ChainDoesNotSupportContract,
  ContractFunctionExecutionError,
  ContractFunctionRevertedError,
  ContractFunctionZeroDataError,
  DataLengthTooLongError,
  DataLengthTooShortError,
  DecodeLogTopicsMismatch,
  EnsAvatarUriResolutionError,
  EstimateGasExecutionError,
  ExecutionRevertedError,
  FeeCapTooHighError,
  FeeCapTooLowError,
  FilterTypeNotSupportedError,
  HttpRequestError,
  InsufficientFundsError,
  InternalRpcError,
  IntrinsicGasTooHighError,
  IntrinsicGasTooLowError,
  InvalidAbiDecodingTypeError,
  InvalidAbiEncodingTypeError,
  InvalidAddressError,
  InvalidArrayError,
  InvalidBytesBooleanError,
  InvalidChainIdError,
  InvalidDefinitionTypeError,
  InvalidHexBooleanError,
  InvalidHexValueError,
  InvalidInputRpcError,
  InvalidLegacyVError,
  InvalidParamsRpcError,
  InvalidRequestRpcError,
  JsonRpcVersionUnsupportedError,
  LimitExceededRpcError,
  MethodNotFoundRpcError,
  MethodNotSupportedRpcError,
  NonceMaxValueError,
  NonceTooHighError,
  NonceTooLowError,
  OffsetOutOfBoundsError,
  ParseRpcError,
  RawContractError,
  RequestError,
  ResourceNotFoundRpcError,
  ResourceUnavailableRpcError,
  RpcError,
  RpcRequestError,
  SizeExceedsPaddingSizeError,
  SwitchChainError,
  TimeoutError,
  TipAboveFeeCapError,
  TransactionExecutionError,
  TransactionNotFoundError,
  TransactionReceiptNotFoundError,
  TransactionRejectedRpcError,
  TransactionTypeNotSupportedError,
  UnknownNodeError,
  UnknownRpcError,
  UrlRequiredError,
  UserRejectedRequestError,
  WaitForTransactionReceiptTimeoutError,
  WebSocketRequestError,
  assertRequest,
  assertTransactionEIP1559,
  assertTransactionEIP2930,
  assertTransactionLegacy,
  boolToBytes,
  boolToHex,
  bytesToBigint,
  bytesToBool,
  bytesToHex,
  bytesToNumber,
  bytesToString,
  concat,
  concatBytes,
  concatHex,
  createClient,
  createPublicClient,
  createTestClient,
  createTransport,
  createWalletClient,
  custom,
  decodeAbiParameters,
  decodeErrorResult,
  decodeEventLog,
  decodeFunctionData,
  decodeFunctionResult,
  defineBlock,
  defineChain,
  defineTransaction,
  defineTransactionReceipt,
  defineTransactionRequest,
  encodeAbiParameters,
  encodeDeployData,
  encodeErrorResult,
  encodeEventTopics,
  encodeFunctionData,
  encodeFunctionResult,
  encodePacked,
  etherUnits,
  fallback,
  formatBlock,
  formatEther,
  formatGwei,
  formatTransaction,
  formatTransactionRequest,
  formatUnits,
  fromBytes,
  fromHex,
  fromRlp,
  getAbiItem,
  getAddress,
  getContract,
  getContractAddress,
  getContractError,
  getCreate2Address,
  getCreateAddress,
  getEventSelector,
  getFunctionSelector,
  getSerializedTransactionType,
  getTransactionType,
  gweiUnits,
  hashMessage,
  hashTypedData,
  hexToBigInt,
  hexToBool,
  hexToBytes,
  hexToNumber,
  hexToString,
  http,
  isAddress,
  isAddressEqual,
  isBytes,
  isHash,
  isHex,
  keccak256,
  labelhash,
  multicall3Abi,
  namehash,
  numberToBytes,
  numberToHex,
  pad,
  padBytes,
  padHex,
  parseAbi,
  parseAbiItem,
  parseAbiParameter,
  parseAbiParameters,
  parseEther,
  parseGwei,
  parseTransaction,
  parseUnits,
  prepareRequest,
  recoverAddress,
  recoverMessageAddress,
  recoverTypedDataAddress,
  serializeTransaction,
  size,
  slice,
  sliceBytes,
  sliceHex,
  stringToBytes,
  stringToHex,
  stringify,
  toBytes,
  toHex,
  toRlp,
  transactionType,
  trim,
  validateTypedData,
  verifyMessage,
  verifyTypedData,
  webSocket,
  weiUnits
};
//# sourceMappingURL=index.mjs.map